import React from 'react';
import { Hero } from './presell/Hero';
import { EverydayMobility } from './presell/EverydayMobility';
import { Discovery } from './presell/Discovery';
import { FinalCta } from './presell/FinalCta';
export function PresellPage() {
  return <div className="w-full bg-white" data-id="element-81" data-mp="3bkvxzp5b1yl7">
      <header className="w-full bg-white border-b border-[#E5E9E7]" data-id="element-82" data-mp="36mb2u44wu53m">
        <div className="max-w-6xl mx-auto px-5 md:px-8 py-5 flex justify-center" data-id="element-83" data-mp="36n2syzfqnami">
          <p className="text-xl md:text-2xl font-bold text-[#22322C] tracking-tight" data-id="element-84" data-mp="2ix8dea41b7yk">
            Dr. Weis{' '}
            <span className="font-light italic text-[#7C9082]" data-id="element-85" data-mp="2dzgmnjf4lrvy">
              Joint Research
            </span>
          </p>
        </div>
      </header>

      <main className="w-full" data-id="element-86" data-mp="2nvjo0n25lmhu">
        <Hero data-id="element-87" data-mp="2nu8myv03esuf" />
        <EverydayMobility data-id="element-88" data-mp="2ntqf1142iq6o" />
        <Discovery data-id="element-89" data-mp="205z4o3238n81" />
        <FinalCta data-id="element-90" data-mp="205fmcl8izwth" />
      </main>

      <footer className="w-full bg-[#F7F9F8] border-t border-[#E5E9E7]" data-id="element-91" data-mp="204o1a4ck1hhg">
        <div className="max-w-3xl mx-auto px-5 md:px-8 py-10 text-center space-y-4" data-id="element-92" data-mp="1v630a2phatry">
          <p className="text-xs text-[#8A9A8F] leading-relaxed" data-id="element-93" data-mp="1cya121el46x">
            The statements on this page have not been evaluated by the Food and
            Drug Administration. This content is for informational purposes only
            and is not intended to diagnose, treat, cure, or prevent any
            disease. Individual experiences vary. Consult your physician before
            starting any new supplement.
          </p>
          <p className="text-xs text-[#8A9A8F] leading-relaxed" data-id="element-94" data-mp="3ekjbnbw4ft6q">
            This page contains affiliate links. We may receive compensation if
            you purchase through them.
          </p>
          <p className="text-sm text-[#8A9A8F]" data-id="element-95" data-mp="3ni1zsp52anmu">
            © {new Date().getFullYear()} Dr. Weis Joint Research. All rights
            reserved.
          </p>
        </div>
      </footer>
    </div>;
}